var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("SkillRadar", {
        attrs: {
          datas: _vm.skillsList,
          fields: _vm.fields,
          "child-key": "jqSkillMaps",
          options: _vm.radarOption,
          "virtual-line": _vm.virtualLineStyle,
          "checkbox-color-type": "marker",
          "label-style": _vm.labelStyle,
          "no-eval-planed": _vm.noEvalPlaned,
          "checkbox-style": {
            marginTop:
              _vm.skillsList.length === 1 || _vm.skillsList.length % 2 === 0
                ? "24px"
                : "0px",
          },
          "close-animate": _vm.closeAnimate,
          "frontend-style": _vm.$route.meta.navCode === 1,
        },
        on: { labelClick: _vm.handleClick },
      }),
      _c("detail-dialog", {
        ref: "detailDialog",
        attrs: {
          skill: _vm.selectSkill,
          "tab-arr-key": "jqSkillMaps",
          title: _vm.$t("pc_gwnl_web_tit_capabilityDetails"),
          "show-skill-level": _vm.skillWithLevel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }